module.exports = __webpack_public_path__ + "img/img_06.4415b58c.png";